import {
  BreakpointsPx,
  ImpContainer,
  ImpFlex,
  ImpHeader,
  ImpHidden,
  ImpPad,
  ImpRewardsDisplay,
  ImpSpacer,
} from '@imprint-payments/imprint-ui';

export function ApplicationLoader() {
  return (
    <ImpFlex direction="column" fluid>
      <ImpHeader isLoading />
      <ImpSpacer height="3xl" mobileHeight="xl" />
      <ImpFlex fluid direction="row" justify="center" gap="l">
        <ImpContainer
          backgroundColor={'white'}
          width="min(534px, 100% - 32px)"
          height="260px"
          borderRadius="10px"
        >
          <ImpPad padding="16px">
            <ImpContainer isLoading width="160px" height="12px" />
            <ImpSpacer height="xs" />
            <ImpContainer isLoading width="100px" height="12px" />
            <ImpSpacer height="l" />
            <ImpContainer isLoading width="160px" height="12px" />
            <ImpSpacer height="xs" />
            <ImpContainer isLoading width="100px" height="12px" />
          </ImpPad>
        </ImpContainer>
        <ImpHidden hideBelow={BreakpointsPx.Application}>
          <ImpRewardsDisplay
            isLoading
            cardImageSrc={''}
            cardName={''}
            rewardsBonus={[]}
          />
        </ImpHidden>
      </ImpFlex>
    </ImpFlex>
  );
}
